<template>
  <li class="drugs__item" v-if="isFiltered">
    <a :href="fact.url" class="drugs__drug" :class="{ 'is-marginless': featured }">
      <div class="drugs__icon" role="presentation">
        <div
          class="drugs__image"
          :style="`background-image: url('${drugImage}');`"
          role="presentation"
        ></div>
      </div>
      <h3 class="drugs__name" :class="drugFact">
        <span>{{ fact.title }}</span>
      </h3>
    </a>
  </li>
</template>

<script>
import axios from 'axios';

export default {
  name: 'drug-fact',
  props: {
    featured: Boolean,
    filter: String,
    id: Number,
  },
  data() {
    return {
      fact: {},
    };
  },
  computed: {
    drugImage() {
      if (this.fact.header_image) {
        return this.fact.header_image.url;
      }
      return '';
    },
    drugFact() {
      try {
        const drugType = this.fact.drug.drug_type.name.toLowerCase();
        return `drugs__name--${drugType}`;
      } catch (error) {
        return '';
      }
    },
    isFiltered() {
      if (!this.fact.drug) {
        return false; // Return false if awaiting axios call
      }
      if (
        !this.filter // no filters
        // filter name is drug fact name
        || this.filter.toLowerCase() === this.fact.drug.name.toLowerCase()
        // filter name is drug effect name
        || this.fact.drug.drug_effects.some(effect => effect.name === this.filter)
        // filter name is drug type name
        || (this.fact.drug.drug_type && this.fact.drug.drug_type.name === this.filter)
        // filter name is street name
        || this.fact.drug.street_names.some(streetName => streetName.name === this.filter)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_API_URL}pages/${this.id}/?fields=-body,-breadcrumbs,-short_description`)
      .then((response) => {
        this.fact = response.data;
        this.$emit('loaded');
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.fact = [];
        }
      });
  },
};
</script>
